import styled from 'styled-components';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
`;

export const BoxAuth = styled.div`
  width: 1068px;
  padding: 40px;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  svg {
    font-size: 4rem;
    align-self: center;
    color: #74a50a;
    margin-bottom: 20px;
  }
  h4 {
    align-self: center;
    font-size: 1.5rem;
    margin-bottom: 2rem;
    color: #6c6c6c;
  }
  img {
    align-self: center;
  }
  p {
    text-align: center;
  }
  a {
    text-align: center;
    color: #74a50a;
    display: block;
    margin: 20px auto;
  }
`;
